import { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import LoginComponent from './LoginComponent';

import { login, onResetRequested, socialAuth } from './actionCreators';

import { isAuthenticated } from '../../utils';
import { required } from '../Forms/utils';

import { history } from '../../store';
import { STYLED_PASSWORD, STYLED_TEXT } from '../Forms/fieldTypes';

const form = 'Login';
// TODO: should be changed to error code
const notAllowedToLoginError = 'Not allowed to login';

const LoginContainer = (props) => {
  const { t } = useTransl();
  const { socialAuth } = props;

  const [userForgotPassword, setUserForgotPassword] = useState(false);

  const isNotAllowedToLogin = useSelector(
    (state) => state?.form?.[form]?.error,
  )?.includes(notAllowedToLoginError);

  const signInWithFacebook = (accessToken) =>
    socialAuth('facebook', { accessToken });

  const signInWithGoogle = ({ credential }) => {
    socialAuth('google-oauth2', { accessToken: credential });
  };

  const signInWithApple = (accessToken) =>
    socialAuth('apple-id', { accessToken });

  const toggleForgotPasswordState = () =>
    setUserForgotPassword(!userForgotPassword);

  useEffect(() => {
    if (isAuthenticated()) {
      history.replace('./');
    }
  }, []);

  const formData = [
    {
      keyName: 'username',
      label: t('title.emailOrPhone'),
      fieldType: STYLED_TEXT,
      validate: [required],
      autoComplete: 'username',
    },
    {
      keyName: 'password',
      label: t('title.password'),
      fieldType: STYLED_PASSWORD,
      validate: [required],
      isHidden: userForgotPassword,
      autoComplete: 'current-password',
    },
  ];

  const loginProps = {
    ...props,
    userForgotPassword,
    formData,
    form,
    signInWithFacebook,
    signInWithGoogle,
    signInWithApple,
    toggleForgotPasswordState,
    isNotAllowedToLogin,
  };
  return <LoginComponent {...loginProps} />;
};

LoginContainer.propTypes = {
  socialAuth: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, ownProps) => {
  const fromLocation = ownProps?.location?.state?.from || {};
  const { pathname, search } = fromLocation;
  const redirectToAfterLogin =
    pathname && search ? `${pathname}${search}` : pathname && `${pathname}`;
  return {
    onSubmit: (data) => login(dispatch, data, redirectToAfterLogin),
    socialAuth: (loginType, data) =>
      socialAuth(dispatch, loginType, data, redirectToAfterLogin),
    onResetRequested: (data) => onResetRequested(dispatch, data),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
